(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    var btn = document.querySelector('[data-article-back]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var ref = document.referrer;
      var sameOrigin = ref && ref.indexOf(window.location.origin) === 0;
      if (sameOrigin && window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = btn.dataset.fallback || '/';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  (function () {
    var btn = document.querySelector('[data-blog-back]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var ref = document.referrer;
      var sameOrigin = ref && ref.indexOf(window.location.origin) === 0;
      if (sameOrigin && window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = btn.dataset.fallback || '/';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    function initEmptyVariants() {
      var container = document.getElementById('no-items-in-the-cart-brother');
      if (!container) return;
      var variants = container.querySelectorAll('[data-variant]');
      if (!variants.length) return;
      if (variants.length === 1) { // case there is only 1
        variants[0].hidden = false;
        return;
      }
      var pick = variants[Math.floor(Math.random() * variants.length)];
      pick.hidden = false;
    }

    initEmptyVariants();

    // Delegated so the handlers keep working after the section re-renders.
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-cart-back]');
      if (!btn) return;
      var ref = document.referrer;
      var sameOrigin = ref && ref.indexOf(window.location.origin) === 0;
      if (sameOrigin && window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = btn.dataset.fallback || '/collections/all';
      }
    });

    var requestId = 0;

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches || !input.matches('[data-cart-qty]')) return;

      var quantity = parseInt(input.value, 10);
      if (isNaN(quantity) || quantity < 0) quantity = 0;
      var max = parseInt(input.getAttribute('max'), 10);
      if (!isNaN(max) && quantity > max) quantity = max;
      input.value = quantity;

      var wrapper = input.closest('[id^="shopify-section-"]');
      if (!wrapper) return;
      var sectionId = wrapper.id.replace('shopify-section-', '');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var current = ++requestId;

      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: input.dataset.key,
          quantity: quantity,
          sections: sectionId
        })
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (current !== requestId) return; // a newer change is in flight
          var html = data.sections && data.sections[sectionId];
          if (!html) {
            window.location.reload();
            return;
          }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById(wrapper.id) || doc.body;

          var freshRows = fresh.querySelectorAll('.cart-page__item');
          var currentRows = wrapper.querySelectorAll('.cart-page__item');

          // Cart emptied (or came back): swap the whole section once.
          if (!freshRows.length || !currentRows.length) {
            wrapper.innerHTML = fresh.innerHTML;
            initEmptyVariants();
            return;
          }

          // Patch rows in place so images never re-render.
          var freshByKey = {};
          freshRows.forEach(function (row) {
            freshByKey[row.dataset.key] = row;
          });

          currentRows.forEach(function (row) {
            var freshRow = freshByKey[row.dataset.key];
            if (!freshRow) {
              row.remove();
              return;
            }
            var qty = row.querySelector('[data-cart-qty]');
            var freshQty = freshRow.querySelector('[data-cart-qty]');
            if (qty && freshQty && qty !== document.activeElement) {
              qty.value = freshQty.value;
            }
            var price = row.querySelector('.cart-page__item-price');
            var freshPrice = freshRow.querySelector('.cart-page__item-price');
            if (price && freshPrice) {
              price.textContent = freshPrice.textContent;
            }
          });

          var totals = wrapper.querySelector('.cart-page__totals');
          var freshTotals = fresh.querySelector('.cart-page__totals');
          if (totals && freshTotals) {
            totals.innerHTML = freshTotals.innerHTML;
          }
        })
        .catch(function () { window.location.reload(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["overview"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var logo = document.querySelector('.hero__logo');
    var card = document.querySelector('.card-3d');
    if (!logo || !card) return;

    // mobile :P
    logo.addEventListener('touchmove', function (e) {
      var touch = e.touches[0];
      var rect = logo.getBoundingClientRect();
      var x = (touch.clientX * window.devicePixelRatio) - rect.left;
      var y = (touch.clientY * window.devicePixelRatio) - rect.top;
      var cx = rect.width / 2;
      var cy = rect.height / 2;
      var rotateX = ((cy - y) / cy) * 10;
      var rotateY = ((x - cx) / cx) * 10;
      card.style.transform = 'rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
    });

    // desktop 
    logo.addEventListener('mousemove', function (e) {
      var rect = logo.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      var cx = rect.width / 2;
      var cy = rect.height / 2;
      var rotateX = ((cy - y) / cy) * 10;
      var rotateY = ((x - cx) / cx) * 10;
      card.style.transform = 'rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
    });

    logo.addEventListener('mouseleave', function () {
      card.style.transform = 'rotateX(0deg) rotateY(0deg)';
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var btn = document.querySelector('[data-buy-back]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var ref = document.referrer;
      var sameOrigin = ref && ref.indexOf(window.location.origin) === 0;
      if (sameOrigin && window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = btn.dataset.fallback || '/collections/all';
      }
    });
  })();

  (function () {
    var gallery = document.querySelector('[data-buy-gallery]');
    if (!gallery) return;
    var images = gallery.querySelectorAll('[data-gallery-image]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.dataset.galleryThumb;
        images.forEach(function (image) {
          image.classList.toggle(
            'buy-page__media-item--active',
            image.dataset.galleryImage === index
          );
        });
        thumbs.forEach(function (other) {
          other.classList.toggle('buy-page__thumb--active', other === thumb);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    var btn = document.querySelector('[data-search-back]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var ref = document.referrer;
      var sameOrigin = ref && ref.indexOf(window.location.origin) === 0;
      if (sameOrigin && window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = btn.dataset.fallback || '/collections/all';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
